<template>
    <div
        :class="width"
        class="h-10px loader-bg"
    ></div>
</template>

<script>
export default {
    name: 'SkeletonLoader',

    props: {
        width: {
            type: String,
            default: 'w-full',
        },
    },
};
</script>

<style lang="scss" scoped>
.loader-bg {
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: #f6f7f8;
    background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
    background-size: 800px 104px;
    position: relative;
    opacity: .4;

    &.w-25 {
        width: 25%;
    }

    &.w-50 {
        width: 50%;
    }

    &.w-75 {
        width: 75%;
    }

    &.w-90 {
        width: 90%;
    }
}

@keyframes placeHolderShimmer{
    0%{
        background-position: -468px 0
    }

    100%{
        background-position: 468px 0
    }
}
</style>
